import { getProfile } from '../../utils/api'

export * from './building'
export * from './layout-map'
export * from './robot'
export * from './robot-map'
export * from './users'

export const useEnableConfigPage = () => {
  const organisation = getProfile()?.organisation
  const whitelist = ['6d8c0443-8466-4d4b-a156-7d9a902adcb0']
  return organisation && whitelist.includes(organisation)
}